import { render, staticRenderFns } from "./OpenSerSecond.vue?vue&type=template&id=299d4d6c&scoped=true"
import script from "./OpenSerSecond.vue?vue&type=script&lang=js"
export * from "./OpenSerSecond.vue?vue&type=script&lang=js"
import style0 from "./OpenSerSecond.vue?vue&type=style&index=0&id=299d4d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299d4d6c",
  null
  
)

export default component.exports